import type { ParentApi } from "@deskpro-product/messenger-api-schemas/messenger-init/types";
import type { Connection } from "penpal";

export default async function getHostUserJwtToken(
  messengerId: string,
  connection?: Connection<ParentApi>,
): Promise<string | undefined> {
  return (await connection?.promise)?.getSignedUserInfo(messengerId);
}
